"use strict";
/*
 * Copyright 2023, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.validatableAttributeNames = void 0;
exports.validatableAttributeNames = ['_isValid'];
//# sourceMappingURL=IValidatable.js.map